import type { IssuePoHeader } from "../api/mrrInventoryApi";

/**
 * Legacy fallback when `poDate` is missing: calendar day in the **browser's local timezone**
 * from an ISO / parseable timestamp. Prefer `header.poDate` from the API (DB `po_date`).
 */
export function parseIsoDatePrefix(iso: string): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    const s = iso.trim();
    return /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : "";
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** PO document date: immutable `po_date` from server (generation day); never shifts with timezone. */
export function poDocumentDate(header: Pick<IssuePoHeader, "createdAt"> & { poDate?: string | null }): string {
  const p = header.poDate?.trim();
  if (p && /^\d{4}-\d{2}-\d{2}$/.test(p)) return p;
  return parseIsoDatePrefix(header.createdAt);
}
